import { render, staticRenderFns } from "./add-edit2.vue?vue&type=template&id=0d330c10&scoped=true"
import script from "./add-edit2.vue?vue&type=script&lang=js"
export * from "./add-edit2.vue?vue&type=script&lang=js"
import style0 from "./add-edit2.vue?vue&type=style&index=0&id=0d330c10&prod&lang=scss&scoped=true"
import style1 from "./add-edit2.vue?vue&type=style&index=1&id=0d330c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d330c10",
  null
  
)

export default component.exports